<template>
  <el-rate
    v-model="localValue"
    :disabled="disabled"
    :show-text="showText"
    :show-score="showScore"
    text-color="#ff9900"
    @change="$emit('change', localValue)" />
</template>

<script>
export default {
  name: 'DaraRating',
  props: {
    value: Number,
    disabled: Boolean,
    showText: Boolean,
    showScore: Boolean,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.localValue = value;
    },
  },
};
</script>
